module.exports = __webpack_public_path__ + "static/media/wrapper-button-restart.8bf58c85.png";